import { Copy } from 'lucide-react'
import { Avatar } from '@/components/ui/avatar'
import { cn, copyToClipboard } from '@/lib/utils'
import type { AuthUser } from '@/stores/types'
import { truncateAddress } from '@/utils/address'

interface UserAvatarInfoProps {
	user: Partial<AuthUser>
	className?: string
	avatarClassName?: string
	textClassName?: string
	showUsername?: boolean
	allowCopy?: boolean
	layout?: 'horizontal' | 'vertical'
}

export function UserAvatarInfo({
	user,
	className,
	avatarClassName,
	textClassName,
	showUsername,
	allowCopy = true,
	layout = 'horizontal',
}: UserAvatarInfoProps) {
	const containerClass =
		layout === 'horizontal' ? 'flex items-center gap-2' : 'flex flex-col space-y-1'
	const displayEmail = user?.email
	const displayAddress = user.walletAddress ? truncateAddress(user.walletAddress) : ''
	return (
		<div className={cn(containerClass, className)}>
			<Avatar className={cn('h-8 w-8 rounded-lg', avatarClassName)}>
				<div className="bg-gradient-to-br from-blue-500 to-purple-600 flex items-center justify-center flex-shrink-0 w-8 h-8 text-xs font-semibold text-white rounded-full">
					{displayEmail ? displayEmail[0].toUpperCase() : displayAddress[0]}
				</div>
			</Avatar>
			<div className={cn('grid flex-1 text-left text-sm leading-tight', textClassName)}>
				{/* username not retrieved at the moment */}
				{showUsername && user.username && (
					<span className="text-sm font-semibold truncate">{user.username}</span>
				)}
				<span className="text-xs truncate">{user.email}</span>
				{user.walletAddress && (
					<div className="flex items-center gap-1">
						<span className="text-xs truncate">
							{truncateAddress(user.walletAddress)}
						</span>
						{allowCopy && (
							<Copy
								className="text-muted-foreground hover:text-foreground w-3 h-3 cursor-pointer"
								onClick={() => copyToClipboard(user.walletAddress!)}
							/>
						)}
					</div>
				)}
			</div>
		</div>
	)
}
